import React from "react";
import './PdfStmt.css'
// import { format } from "date-fns";
import format from 'date-fns/format'
const dateFormat = "dd-MM-yyyy";

const PdfStatementList = ({ member }) => {

    const memberInfo = member?.member
    const payments = member?.payments
    const ledger = member?.ledger

    let totalPayment = 0;
    payments?.map(paymt => {
        totalPayment += paymt.payment_amount
        return totalPayment
    })

    return (
        <>
            {member?.length < 0 ? (
                "Sorry, no statement to be generated"
            ) : (
                <>
                    <div className="stmt-report">
                        <div className="stmt-image">
                            <img src="/images/logos/proforum_main.jpg" alt="" className="logo" />
                            <h3>NDC PROFESSIONAL FORUM</h3>
                        </div>
                        <div className="stmt-title">
                            Member Summary Statement
                        </div>
                    </div>
                    <div className="panel panel-default panel-br-4">
                        <div className="panel-heading">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h4 className="panel-title">
                                        <strong>MEMBER PERSONAL INFORMATION</strong>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div className="table-responsive lg">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>FULL NAME</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "justify", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.title} {memberInfo?.first_name} {memberInfo?.middle_name} {memberInfo?.last_name}</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>DATE JOINED</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;    {format(new Date(memberInfo?.date_joined),dateFormat)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>PF NUMBER</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.pf_number}</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>VOTER ID NUMBER</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.voter_id_number}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>MOBILE NUMBER</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.mobile_number}</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>GENDER</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.gender}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>EMAIL ADDRESS</td>
                                            <td style={{ fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.email}</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>PROFESSION</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.profession}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>REGION</td>
                                            <td style={{ fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.region}</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>CONSTITUENCY</td>
                                            <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.constituency}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="panel panel-default panel-br-4">
                        <div className="panel-heading">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h4 className="panel-title">
                                        <strong>MEMBER PAYMENT TRANSACTIONS</strong>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div className="table-responsive lg">
                                <table className='table table-borderless table-hover table-striped'>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>Year</th>
                                            <th style={{ textAlign: "center" }}>Payment Date</th>
                                            <th style={{}}>Receipt Number</th>
                                            <th style={{}}>Payment Type</th>
                                            <th style={{ whiteSpace: "nowrap" }}>Description</th>
                                            <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payments?.map(payment => (
                                            <tr key={payment.id}>
                                                <td style={{ textAlign: "center" }}>{payment.year}</td>
                                                <td style={{ textAlign: "center" }}>{format(new Date(payment.payment_date), dateFormat)}</td>
                                                <td style={{ textAlign: "left" }}>{payment.receipt_number}</td>
                                                <td style={{ textTransform: "uppercase" }}>{payment.payment_type}</td>
                                                <td style={{ whiteSpace: "nowrap" }}>{payment.description}</td>
                                                <td style={{ textAlign: "right" }}>{payment.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="6"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5" className="border-bottom" style={{ width: "55%", textAlign: "left", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                                TOTAL PAYMENT
                                            </td>
                                            {totalPayment < 0 ? (
                                                <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                                    ({(totalPayment * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                                    {totalPayment.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td colSpan="7" style={{ width: "95%", borderBottom: "5px" }}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="panel panel-default panel-br-4">
                        <div className="panel-heading">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h4 className="panel-title">
                                        <strong>MEMBER LEDGER ACCOUNT (Mandatory Payments)</strong>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">

                            <div className="table-responsive lg">
                                <table className="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>YEAR</th>
                                            <th style={{ textAlign: 'right' }}>OPENING BALANCE </th>
                                            <th style={{ textAlign: 'right' }}>EXPECTED PAYMENT</th>
                                            <th style={{ textAlign: 'right' }}>AMOUNT PAID</th>
                                            <th style={{ textAlign: 'right' }}>CLOSING BALANCE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ledger?.map(ledger => <tr key={ledger.id} style={{ cursor: "pointer" }}>
                                            <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-center">{ledger.year}</td>
                                            {ledger.opening_balance < 0 ? (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">({(ledger.opening_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.opening_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                            {ledger.expected_total_amount < 0 ? (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">({(ledger.expected_total_amount * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.expected_total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                            <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.total_amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                            {ledger.closing_balance < 0 ? (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">({(ledger.closing_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })})</td>
                                            ) : (
                                                <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.closing_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                            )}
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div></>
            )}
        </>
    )
}

export default PdfStatementList